import { NavLink } from 'react-router-dom';

export default function MobileLogo() {
  return (
    <NavLink to='/swapandtop/'>
      <svg className='mobile-logo' viewBox='0 0 258.25 159.01'>
        <g>
          <g>
            <path
              className='mobile-logo-path'
              d='M56.45,86.13c0-3.39-2.61-5.21-6-5.21-4.69,0-8.47,3.39-8.47,8.08,0,3.26,1.69,6.65,5.21,11.08l18.38,21.77c.78-1.17,1.56-2.35,2.35-3.65l6.26-8.21h22.42l-8.21,11.34c-3.52,5.48-7.04,10.43-10.82,14.73l18.25,21.51h-25.94l-7.04-8.21c-9.39,6.39-19.95,9.65-31.94,9.65-19.03,0-30.9-9-30.9-23.47s10.3-25.16,24.64-31.29c-2.87-4.43-4.04-8.21-4.04-12.25,0-16.3,13.69-27.12,32.59-27.12,16.3,0,24.38,8.48,24.38,18.9,0,1.3-.13,2.48-.39,3.91h-20.86c.13-.52,.13-1.04,.13-1.57Zm-4.95,50.06l-16.82-19.68c-7.3,3.39-11.86,8.73-11.86,14.86,0,5.47,4.43,9.65,12.52,9.65,6,0,11.34-1.7,16.17-4.82Z'
            />
            <path
              id='Path_1-2'
              data-name='Path 1-2'
              className='mobile-logo-path'
              d='M183.48,102.33l-20.1,5.43-.59,1.14-4.22,1.14-1.5,.4-4.11,1.11-1.1-.69-6.5,1.76c-1.7,.47-3.46-.51-3.95-2.21l-.91-3.27,39.09-10.56c-.06-.07-.13-.14-.19-.22l-38.94,10.53-.36-1.29c-.14-.52,.16-1.05,.68-1.2,0,0,.01,0,.02,0l36.74-9.94c-5.29-4.85-12.23-7.5-19.41-7.4-15.45,.17-27.91,12.76-27.66,27.94,.05,3.04,.6,6.04,1.65,8.9,1.9-1.5,3.64-3.03,4.53-3.83,2.16-1.96,7.12-3.27,13.3-1.14,1.58,.53,3.24,.8,4.92,.81,.57,.01,1.13-.07,1.67-.24l4.92-1.45c.96-.29,1.98,.25,2.28,1.21h0c.03,.1,.05,.2,.06,.3,4.67-1.28,17.19-4.9,17.94-4.98,.47-.05,1,.57,.2,1.15-3.73,2.7-20.99,15.35-23.04,15.8-.34,.06-.69,.09-1.03,.07-4.12-.05-16.46-.65-16.46-.65-.08,0-.15,.02-.21,.07-.34,.29-1.6,1.39-2.95,2.57,5.31,5.44,12.6,8.49,20.2,8.47,15.31,.13,27.83-12.18,27.97-27.49,0-4.25-.99-8.45-2.92-12.24h0Z'
            />
            <path
              className='mobile-logo-path'
              d='M24.67,42.07h14.92c-.33,4.11,2.01,6.87,6.87,6.87,4.19,0,7.04-1.84,7.04-5.45,0-9.47-25.14-7.21-25.31-24.64C28.03,6.96,37.75,0,51.07,0s21.62,6.7,20.53,17.6h-15.25c.5-3.69-1.76-6.29-6.03-6.29-4.02,0-6.79,2.1-6.79,5.45,0,9.05,25.39,8.13,25.39,25.48,0,10.39-8.72,18.02-22.88,18.02-13.16,0-22.79-6.2-21.37-18.19Z'
            />
            <path
              className='mobile-logo-path'
              d='M92.55,12.91l.67,33.44,13.83-33.44h15.17l2.09,33.44,12.4-33.44h13.49l-20.95,46.76h-15.84l-2.01-30.34-12.99,30.34h-15.75l-4.44-46.76h14.33Z'
            />
            <path
              className='mobile-logo-path'
              d='M173.51,12.23c6.96,0,11.31,3.18,13.16,7.29l1.17-6.62h14.33l-8.3,46.76h-14.33l1.26-6.62c-3.35,4.11-8.88,7.29-15.84,7.29-11.4,0-18.86-9.38-16.26-24.13,2.6-14.75,13.32-23.97,24.81-23.97Zm2.01,12.49c-5.36,0-10.98,4.02-12.23,11.48-1.34,7.46,2.77,11.65,8.13,11.65s10.98-4.11,12.32-11.56c1.34-7.46-2.77-11.56-8.21-11.56Z'
            />
            <path
              className='mobile-logo-path'
              d='M241.39,12.23c11.48,0,18.94,9.22,16.34,23.97-2.6,14.75-13.33,24.13-24.81,24.13-6.87,0-11.23-3.27-13.16-7.21l-5.11,28.83h-14.33l12.15-69.05h14.33l-1.17,6.62c3.35-4.11,8.88-7.29,15.75-7.29Zm-6.37,12.49c-5.45,0-10.98,4.11-12.32,11.56-1.34,7.46,2.77,11.56,8.13,11.56s11.06-4.19,12.4-11.65c1.26-7.46-2.85-11.48-8.21-11.48Z'
            />
            <path
              className='mobile-logo-path'
              d='M140.93,76l-1.93,11.31h-15.67l-8.38,47.52h-14.33l8.38-47.52h-15.59l2.01-11.31h45.5Z'
            />
            <path
              className='mobile-logo-path'
              d='M228.46,87.4c11.48,0,18.94,9.22,16.34,23.97-2.6,14.75-13.32,24.13-24.8,24.13-6.87,0-11.23-3.27-13.16-7.21l-5.11,28.83h-14.33l12.15-69.05h14.33l-1.17,6.62c3.35-4.11,8.88-7.29,15.75-7.29Zm-6.37,12.49c-5.45,0-10.98,4.11-12.32,11.56-1.34,7.46,2.77,11.56,8.13,11.56s11.06-4.19,12.4-11.65c1.26-7.46-2.85-11.48-8.21-11.48Z'
            />
          </g>
        </g>
      </svg>
    </NavLink>
  );
}
